export default "__VITE_PUBLIC_ASSET__2bfdcffe__"